import React from 'react';
import ProductSlider from './ProductSlider';

const ProductSliderWithProps = (props: any) => {
  return (
    <ProductSlider
      title={props.title}
      products={props.products}
      ctaLink={props.ctaLink}
      ctaText={props.ctaText}
      theme={props.theme}
      includePadding
    />
  );
};

export default ProductSliderWithProps;
